import { Router } from '@angular/router';
import { MotorProposal } from './../../../Models/MotorProposal';
import { Component, OnDestroy, DoCheck } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { restURL } from '../../../Models/restURL';
import { Subscription } from 'rxjs';
import { motorProposalService } from '../../../Services/motorProposalService';
import { BindMdl } from '../../../Models/BindMdl';
import { LanguageService } from '../../../Services/languageService';
import { KeyValueChanges, KeyValueDiffer, KeyValueDiffers } from '@angular/core';
import { MotorproposalTrackingService } from '../../../Services/MotorproposalTrackingService';
@Component({
  selector: 'VehicleDetails',
  templateUrl: './VehicleDetails.html',
  styleUrls: ['./VehicleDetails.css']
})
export class VehicleDetails {
  public prObj: MotorProposal = new MotorProposal();
  public bindObj: BindMdl = new BindMdl();
  //public httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
  public isShowLoading: boolean;
  public LngSubscription: Subscription;
  public Lng: string;
  public showTPLCompOnly: boolean;
  public showCompOnly: boolean;
  public isError: boolean;
  public ErrorMsg: string;
  public isOfficeAddr: boolean;
  public isSubmitted: boolean;

  public constructor(private router: Router, private http: HttpClient, private url: restURL, private proposalService: motorProposalService, private lngService: LanguageService, private trackingObj: MotorproposalTrackingService) {
    this.isOfficeAddr = false;
    this.isSubmitted = false;
    this.LngSubscription = this.lngService.grtLng().subscribe(lng => { this.Lng = lng });

    if (sessionStorage.getItem("Language") != null) {
      this.Lng = sessionStorage.getItem("Language");
    }
    else {
      this.Lng = "en";
    }
    this.prObj = this.proposalService.getProposalObj();
    this.isShowLoading = false;
    this.isError = false;
    this.ErrorMsg = "";
    this.bindObj = this.proposalService.getBindObj();
  }

  goPrev() {
    this.proposalService.saveProposalObj(this.prObj);
    this.proposalService.saveBindObj(this.bindObj);
    sessionStorage.setItem("CurrentRoute", "PremiumInfo");
    this.router.navigate(['NewDashboard/MotorProposalForm/PremiumInfo']);

  }
  //<<<<<<<<<Start>>>>>>>>>>>>>
  goNext(valid) {

    if (!valid) {
      this.isSubmitted = true;
      return;
    }

    this.isSubmitted = true;
    this.proposalService.saveProposalObj(this.prObj);
    this.proposalService.saveBindObj(this.bindObj);
    if (this.prObj.isEditProposal == false) {
      this.prObj.trackingObj.ScreenNo = "P";
      this.trackingObj.saveTrackStatus(this.prObj)
    }

    // if (this.prObj.SelectedProductCode == "5520" && this.prObj.isCompSelected && this.prObj.vehcileObj.Vehicle_DefType == 2) {
    //   sessionStorage.setItem("CurrentRoute", "uploads");
    //   this.router.navigate(['NewDashboard/MotorProposalForm/uploads']);
    // }
    // else {
    //   sessionStorage.setItem("CurrentRoute", "ReviewConfirm");
    //   this.router.navigate(['NewDashboard/MotorProposalForm/ReviewConfirm']);
    // }
    if (localStorage.getItem("Channel") == "Kiosk" || this.prObj.IsRenewal==true) {
      sessionStorage.setItem("CurrentRoute", "ReviewConfirm");
      this.router.navigate(['NewDashboard/MotorProposalForm/ReviewConfirm']);
    }
    else {
      sessionStorage.setItem("CurrentRoute", "uploads");
      this.router.navigate(['NewDashboard/MotorProposalForm/uploads']);
    }

  }
  //<<<<<<<<<End>>>>>>>>>>>>>



}




// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/MotorPortal/VehicleDetails/VehicleDetails.ts